import { useCallback, useEffect, useState } from 'react';
import { API } from '../../api';
import { PagedResultState } from '../../common/CommonResult';
import queryString from 'query-string';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  Layout,
  Select,
  Space,
  Table,
  TablePaginationConfig,
  Popconfirm,
  message,
  Tag,
  Card,
  Input,
  Button,
  Alert,
  Form,
} from 'antd';
import { AddressCascaderOld } from '../../lib/AddressCascaderOld';
import { ScanModal } from '../../lib/parcel/ScanModal';
import dayjs from 'dayjs';
import { ForeignCustomers } from '../../lib/ForeignCustomer';

import CustomerSelect from '../../lib/CustomerSelect';
import AddressCascader from '../../lib/AddressCascader';
import AddressZipcodeCascader from '../../lib/AddressZipcodeCascader';
import { ReloadOutlined } from '@ant-design/icons';
import CustomerInput from '../../lib/CustomerInput';

export const ForeignTransport = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchState, changeSearchState] = useState<any>({});
  const [query, changeQuery] = useState('');
  const [state, changeState] = useState<PagedResultState<any>>({
    loading: true,
    result: {},
  });
  const [loadingSync, changeLoadingSync] = useState<string | null>(null);
  const [syncResult, changeSyncResult] = useState<any>({});
  useEffect(() => {
    if (location.search) {
      changeSearchState(queryString.parse(location.search));
      fetchContent(location.search);
    } else {
      setTimeout(() => {
        navigate(`/foreign/transports?page=1`);
      }, 100);
    }
  }, [location.search]);
  useEffect(() => {
    if (searchState) {
      navigate(`/foreign/transports?${queryString.stringify(searchState)}`);
    }
    changeQuery(searchState.query);
  }, [searchState]);
  const orderDraftSync = useCallback(
    async (manifestNumber: string) => {
      if (loadingSync !== null) {
        message.error('Зэрэг уншуулж болохгүй');
        return;
      }
      changeLoadingSync(manifestNumber);
      try {
        const response = await API.post({ apiVersion: 'api' })('/foreign/sync', {
          manifestNumber,
        });
        changeSyncResult(response.result);
      } catch (e: any) {
        message.error(e.message);
      } finally {
        changeLoadingSync(null);
      }
    },
    [loadingSync]
  );
  const fetchContent = async (filter: any) => {
    try {
      changeState({ loading: true, result: {} });
      const response = await API.get({ apiVersion: 'api' })(`/foreign/transport/list${filter}`);
      changeState({ loading: false, result: response.result });
    } catch (e) {
      changeState({ loading: false, error: true, result: {}, errors: e });
    }
  };
  const handleTableChange = (pagination: TablePaginationConfig) => {
    const params = queryString.parse(location.search);
    const search = {
      ...params,
      page: pagination.current || 1,
      size: pagination.pageSize,
    };
    navigate(`/order_draft/transports?${queryString.stringify(search)}`);
  };
  const columns = [
    {
      title: '№',
      dataIndex: 'no',
      width: 70,
    },
    {
      title: 'Тээвэр №',
      dataIndex: 'manifestNumber',
      width: 150,
      render: (data: any, row: any) => (
        <Link to={`/foreign/transports/${row.manifestNumber}`}>{data}</Link>
      ),
      key: 'manifestNumber',
    },
    {
      title: 'Харилцагч',
      dataIndex: 'customer',
      width: 150,
      render: (data: any) => data?.name,
      key: 'customerName',
    },
    {
      title: 'Богц',
      dataIndex: 'packageCount',
      width: 80,
      render: (data: any, row: any) => (
        <Link to={`/order_draft/packages?page=1&manifestNumber=${row.manifestNumber}`}>{data}</Link>
      ),
      key: 'packageCount',
    },
    {
      title: 'Илгээмж',
      dataIndex: 'parcelCount',
      render: (data: any, row: any) => (
        <Link to={`/order_draft/parcels?page=1&manifestNumber=${row.manifestNumber}`}>{data}</Link>
      ),
      width: 80,
      key: 'parcelCount',
    },
    {
      title: 'Огноо',
      dataIndex: 'createdAt',
      render: (row: any) => dayjs(row).format('YYYY-MM-DD HH:mm:ss'),
      key: 'createdAt',
    },
    {
      title: 'Action',
      render: (row: any) => (
        <Space wrap>
          <Button
            loading={loadingSync === row.manifestNumber}
            onClick={() => orderDraftSync(row.manifestNumber)}
            type="primary"
            shape="circle"
            icon={<ReloadOutlined />}
          />
        </Space>
      ),
    },
  ];
  return (
    <Layout.Content style={{ margin: '24px 16px 0' }}>
      <Card
        title={`Урьдчилсан захиалгын тээвэр - ${state.result?.total ?? 0}`}
        extra={<Button type="primary">Тээвэр үүсгэх</Button>}
      >
        <Space wrap style={{ marginBottom: 15 }}>
          <Input.Search
            allowClear
            placeholder="Тээврийн дугаар"
            value={query}
            onChange={(e) => changeQuery(e.target.value)}
            onSearch={(value) => {
              let q = undefined;
              if (value) {
                q = value;
              }
              changeSearchState({ ...searchState, query: q });
            }}
            style={{ width: 200 }}
          />

          <CustomerSelect
            showSearch
            defaultQuery={{ type: 'CN' }}
            allowClear
            value={searchState.customer}
            onChange={(e) => changeSearchState({ ...searchState, customer: e, page: 1 })}
          />
        </Space>
        {syncResult.total && (
          <Alert
            style={{ marginBottom: 15 }}
            message={`Нийт ${syncResult.total} амжилттай - ${syncResult.success} Хаягийн алдаатай - ${syncResult.fail}`}
            type="success"
            closable
            afterClose={() => changeSyncResult({})}
          />
        )}
        <Table
          pagination={{
            pageSize: state.result.size,
            current: state.result.page,
            total: state.result.total,
          }}
          onChange={handleTableChange}
          loading={state.loading}
          dataSource={state.result.data}
          columns={columns}
          rowKey="no"
        />
      </Card>
      <ScanModal open={false} list={[]} onInsert={(e) => console.log(e)} />
    </Layout.Content>
  );
};
